import { Component, Input } from '@angular/core';

@Component({
  selector: 'interface-widget-preview',
  template: `<div class="preview container">
  <div class="cover"></div>
  <div class="logo">
    <i [class]="widgetData?.icon"></i>
  </div>
  <div class="content">
    <div class="heading">{{ widgetData?.title }}</div>
    <div class="description">
      {{ widgetData?.description }}
    </div>
  </div>
</div>`,
  styles: [`.preview{width:100%;padding:10px;position:relative;border-bottom:1px solid #ccc}.preview .cover{position:absolute;top:0;right:0;left:0;bottom:0;background-color:rgba(214,214,214,.055);z-index:111}.preview .content,.preview .logo{display:inline-block;height:100%;vertical-align:middle;padding-left:10px}.preview .logo{max-width:30%;text-align:center;padding:10px 20px;border:1px solid #ccc}.preview .content{max-width:70%;text-align:left}`],
})
export class WidgetPreviewComponent {
  @Input('data') widgetData: any;

  constructor() { }
}
